import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { CustomersEffectsModule } from '@appStore/customers/effects';
import { reducers } from '@appStore/customers/reducers';
import * as fromServices from '@appStore/customers/services';

export * from '@appStore/customers/reducers';
export * from '@appStore/customers/effects';
export * from '@appStore/customers/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('customers', reducers), CustomersEffectsModule],
  providers: [...fromServices.services]
})
export class CustomersStoreModule {}
